import { missingTitleOrSubtitle } from 'govbr.frontend.policy/helpers/validations';
import { defineMessages } from 'react-intl';

import { servicesSchema } from './schema';
import ServicesEdit from './ServicesEdit';
import ServicesView from './ServicesView';

import iconSVG from '@plone/volto/icons/enterprise.svg';

const messages = defineMessages({
  defaultServiceBlockSubtitle: {
    id: 'defaultServiceBlockSubtitle',
    defaultMessage: 'Featured services',
  },
});

const initialValue = ({ id, value, formData, intl }) => {
  return {
    ...formData.blocks[id],
    subtitle: intl.formatMessage(messages.defaultServiceBlockSubtitle),
    title: '',
  };
};

const applyConfig = (config) => {
  config.blocks.blocksConfig.servicesBlock = {
    id: 'servicesBlock',
    title: 'Services',
    group: 'govbr',
    icon: iconSVG,
    view: ServicesView,
    edit: ServicesEdit,
    blockSchema: servicesSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    initialValue,
    security: {
      addPermission: [],
      view: [],
    },
  };
  config.registerUtility({
    type: 'validator',
    name: 'missingTitleOrSubtitle',
    dependencies: {
      blockType: 'servicesBlock',
      fieldName: 'subtitle',
    },
    method: missingTitleOrSubtitle,
  });
  return config;
};

export default applyConfig;
